import { z } from 'zod';

export const BiaRpoRecommendationSchema = z.object({
    _id: z.string().optional(),
    application: z.string().min(1, 'Application is required'),
    backupFreq: z.string().optional(),
    restoreTime: z.string().optional(),
    recommendedRpo: z.string().optional(),
    remarks: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
});
